import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Body,
  Button,
  TrevorComponent,
  TrevorIcon,
} from '@trevor/ui-components';

import { useDatasourceId } from '@/hooks';
import {
  NEAR_LIMIT,
  NONE,
  OVER_LIMIT,
  useGetCreditConsumptionWarningQuery,
} from '@/features/credits/apiSlice';
import { selectLimitedAccess } from '@/features/credits/store-selectors';
import { DATASOURCES_URL_PATH } from '@/routing/paths';
import {
  ActionContainer,
  CreditLimitWarningContainer,
} from '@/features/credits/components/CreditLimitWarning/CreditLimitWarning.styles';

const WARNING_TYPE_TO_MESSAGE = {
  [NONE]: null,
  [NEAR_LIMIT]:
    'You are nearing the credits limit of the Free Plan. Add your billing info to continue using Trevor.io',
  [OVER_LIMIT]:
    'You have now reached the credits limit of the Free Plan. Add your billing info to continue using Trevor.io',
};

export const CreditLimitWarning: TrevorComponent = () => {
  const datasourceId = useDatasourceId();
  const isLimitedAccess = useSelector(selectLimitedAccess);
  const { data: warningType, isLoading } =
    useGetCreditConsumptionWarningQuery(datasourceId);
  const billingUrl = `${DATASOURCES_URL_PATH}/${datasourceId}/billing`;
  const isBilling = !!useMatch({ path: billingUrl, end: false });

  if (isLoading || !warningType || warningType === NONE || isLimitedAccess) {
    return null;
  }

  return (
    <CreditLimitWarningContainer>
      <TrevorIcon name="error" size="md" />
      <Body variant={2}>{WARNING_TYPE_TO_MESSAGE[warningType]}</Body>
      <ActionContainer>
        {!isBilling && (
          <Link to={`/datasources/${datasourceId}/billing`}>
            <Button size="small">Add billing info</Button>
          </Link>
        )}
        <a href="https://trevor.io/pricing/" target="_blank">
          <Button variant="secondary" size="small">
            View pricing
          </Button>
        </a>
      </ActionContainer>
    </CreditLimitWarningContainer>
  );
};
